function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.00005 11.5894C6.00005 11.5894 8.8088 12.9937 8.8088 11.1212C8.8088 9.43339 6.00005 10.2609 6.00005 8.78062C6.00005 7.37624 7.87255 7.37625 8.8088 8.3125",
  stroke: "#00AAFF",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.39911 12.6175L7.39911 7",
  stroke: "#00AAFF",
  strokeWidth: 0.9,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7496 4.37442L20.55 3.84083V20.55H3.45V3.84083L4.25038 4.37442L4.5 4.54083L4.74962 4.37442L6 3.54083L7.25038 4.37442L7.5 4.54083L7.74962 4.37442L9 3.54083L10.2504 4.37442L10.5 4.54083L10.7496 4.37442L12 3.54083L13.2504 4.37442L13.5 4.54083L13.7496 4.37442L15 3.54083L16.2504 4.37442L16.5 4.54083L16.7496 4.37442L18 3.54083L19.2504 4.37442L19.5 4.54083L19.7496 4.37442Z",
  stroke: "#00AAFF",
  strokeWidth: 0.9
});
var _ref4 = /*#__PURE__*/React.createElement("line", {
  x1: 5.45,
  y1: 16.55,
  x2: 18.55,
  y2: 16.55,
  stroke: "#00AAFF",
  strokeWidth: 0.9,
  strokeLinecap: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 5.45,
  y1: 14.55,
  x2: 11.55,
  y2: 14.55,
  stroke: "#00AAFF",
  strokeWidth: 0.9,
  strokeLinecap: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 13.45,
  y1: 14.55,
  x2: 18.55,
  y2: 14.55,
  stroke: "#00AAFF",
  strokeWidth: 0.9,
  strokeLinecap: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 11.45,
  y1: 12.55,
  x2: 18.55,
  y2: 12.55,
  stroke: "#00AAFF",
  strokeWidth: 0.9,
  strokeLinecap: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 11.45,
  y1: 10.55,
  x2: 18.55,
  y2: 10.55,
  stroke: "#00AAFF",
  strokeWidth: 0.9,
  strokeLinecap: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 11.45,
  y1: 8.55,
  x2: 15.55,
  y2: 8.55,
  stroke: "#00AAFF",
  strokeWidth: 0.9,
  strokeLinecap: "round"
});
const SvgInvoice = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInvoice, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/invoice.b35ac599.svg";
export { ForwardRef as ReactComponent };